export const walkMeVariables = {
  appName: "TNC LossViewer Web",
};
